(() => {
  const ROOT_SELECTOR = '[data-cs-shop]';

  const STALE_FULFILLMENT_ATTRIBUTES = [
    'Fulfillment Category',
    'Fulfillment Type',
    'Fulfillment Option Handle',
    'Fulfillment Option Name',
    'Pickup Event ID',
    'Pickup Date',
    'Pickup Day',
    'Pickup Location',
    'Pickup City State',
    'Pickup Address',
    'Pickup Window',
    'Pickup Instructions',
    'Delivery Event ID',
    'Delivery Date',
    'Delivery Day',
    'Delivery Area',
    'Delivery Window',
    'Delivery Zip Code',
    'Delivery Instructions',
    'Shipping Event ID',
    'Shipping Option',
    'Requested Delivery Date',
    'Requested Delivery Day',
    'Estimated Ship Date',
    'Shipping Method',
    'Checkout Method To Select',
    'Shopping Path',
    'Porch Live Purchase',
    'Thursday Preorder Close Time',
    'Thursday Live Open Time',
    'Thursday Live Close Time',
  ];

  class ColdSugarShop {
    constructor(root) {
      if (!root || root.dataset.csShopReady === 'true') return;

      this.root = root;
      document.body.classList.add('cs-shop-page-active');
      this.suppressShopFloatingRewards();

      this.tabs = Array.from(root.querySelectorAll('[data-shop-mode]'));
      this.panels = Array.from(root.querySelectorAll('[data-shop-panel]'));
      this.defaultMode = root.dataset.defaultMode === 'shipping' ? 'shipping' : 'local';
      this.activeMode = this.defaultMode;
      this.modeMap = this.parseModeMap();
      this.fulfillmentOptions = this.parseFulfillmentOptions();
      this.shoppingContext = this.resolveShoppingContext();
      this.dialog = root.querySelector('[data-cs-mode-dialog]');
      this.locationDialog = root.querySelector('[data-cs-location-dialog]');
      this.pendingAdd = null;
      this.lastFocusedElement = null;
      this.locationDialogTrigger = null;
      this.pendingLocationHandle = '';
      this.locationSwitchInProgress = false;
      this.shippingBoxCartUnsubscriber = null;
      this.shopDockExpandedAtY = window.scrollY;

      this.root.dataset.csShopReady = 'true';
      this.bindEvents();
      this.loadInitialState();
    }

    bindEvents() {
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => {
          this.setMode(tab.dataset.shopMode, { updateUrl: true });
        });

        tab.addEventListener('keydown', (event) => {
          const handledKeys = ['ArrowLeft', 'ArrowRight', 'Home', 'End'];
          if (!handledKeys.includes(event.key)) return;

          event.preventDefault();

          let nextIndex = index;

          if (event.key === 'ArrowLeft') {
            nextIndex = index === 0 ? this.tabs.length - 1 : index - 1;
          }

          if (event.key === 'ArrowRight') {
            nextIndex = index === this.tabs.length - 1 ? 0 : index + 1;
          }

          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = this.tabs.length - 1;

          this.tabs[nextIndex].focus();
          this.setMode(this.tabs[nextIndex].dataset.shopMode, { updateUrl: true });
        });
      });

      this.panels.forEach((panel) => {
        panel.querySelectorAll('[data-shop-category]').forEach((button) => {
          button.addEventListener('click', () => {
            this.applyCategory(panel, button.dataset.shopCategory, { updateUrl: true });
          });
        });
      });

      this.root.querySelectorAll('[data-shop-jump-current]').forEach((button) => {
        button.addEventListener('click', () => {
          const category =
            button.dataset.shopJumpCategory ||
            'merch';

          const panel =
            this.getPanel(this.activeMode);

          const row =
            panel?.querySelector(
              `[data-shop-row="${this.escapeSelector(category)}"]`
            );

          if (!row) return;

          row.scrollIntoView({
            behavior:
              this.prefersReducedMotion()
                ? 'auto'
                : 'smooth',
            block: 'start',
          });
        });
      });

      this.root.querySelectorAll('[data-cs-quick-add-form]').forEach((form) => {
        this.bindQuickAddForm(form);
      });

      this.bindDialog();
      this.bindLocationDialog();
      this.bindShippingBoxInfo();
      this.bindShopDockBehavior();
    }

    suppressShopFloatingRewards() {
      const hideRewardsLauncher = () => {
        const knownSelectors = [
          '#smile-ui-container',
          '#smile-ui-lite-container',
          '[id^="smile-ui"]',
          '[class*="smile-launcher"]',
          '[class*="smile_launcher"]',
          'iframe[title*="Rewards" i]',
          'iframe[title*="Smile" i]',
          'iframe[src*="smile.io" i]',
          'iframe[src*="smilecdn" i]'
        ];

        document
          .querySelectorAll(
            knownSelectors.join(',')
          )
          .forEach((element) => {
            let target = element;

            if (
              element.tagName === 'IFRAME' &&
              element.parentElement
            ) {
              target = element.parentElement;
            }

            if (!target) {
              return;
            }

            target.style.setProperty(
              'display',
              'none',
              'important'
            );

            target.style.setProperty(
              'visibility',
              'hidden',
              'important'
            );

            target.style.setProperty(
              'pointer-events',
              'none',
              'important'
            );
          });

        /*
          Smile's launcher markup can change independently of
          the theme. As a fallback, hide only a fixed/sticky
          element whose visible label is exactly "Rewards".
          This runs only on the Cold Sugar Shop page.
        */
        document
          .querySelectorAll(
            'button, a, div, span'
          )
          .forEach((element) => {
            if (
              String(
                element.textContent || ''
              ).trim() !== 'Rewards'
            ) {
              return;
            }

            let current = element;

            for (
              let depth = 0;
              depth < 6 &&
              current &&
              current !== document.body;
              depth += 1
            ) {
              const style =
                window.getComputedStyle(
                  current
                );

              if (
                style.position === 'fixed' ||
                style.position === 'sticky'
              ) {
                current.style.setProperty(
                  'display',
                  'none',
                  'important'
                );

                current.style.setProperty(
                  'visibility',
                  'hidden',
                  'important'
                );

                current.style.setProperty(
                  'pointer-events',
                  'none',
                  'important'
                );

                break;
              }

              current =
                current.parentElement;
            }
          });
      };

      let scheduled = false;

      const scheduleHide = () => {
        if (scheduled) {
          return;
        }

        scheduled = true;

        window.requestAnimationFrame(
          () => {
            scheduled = false;
            hideRewardsLauncher();
          }
        );
      };

      hideRewardsLauncher();

      this.shopRewardsObserver =
        new MutationObserver(
          scheduleHide
        );

      this.shopRewardsObserver.observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    }

    bindShippingBoxInfo() {
      const dialog =
        this.root.querySelector(
          '[data-cs-shipping-box-info]'
        );

      const trigger =
        this.root.querySelector(
          '[data-cs-shipping-box-info-open]'
        );

      const close =
        dialog?.querySelector(
          '[data-cs-shipping-box-info-close]'
        );

      if (!dialog || !trigger) {
        return;
      }

      trigger.addEventListener(
        'click',
        () => {
          if (
            typeof dialog.showModal ===
            'function'
          ) {
            dialog.showModal();
          } else {
            dialog.setAttribute(
              'open',
              ''
            );
          }
        }
      );

      close?.addEventListener(
        'click',
        () => {
          if (
            typeof dialog.close ===
            'function'
          ) {
            dialog.close();
          } else {
            dialog.removeAttribute(
              'open'
            );
          }
        }
      );

      dialog.addEventListener(
        'click',
        (event) => {
          if (
            event.target === dialog
          ) {
            if (
              typeof dialog.close ===
              'function'
            ) {
              dialog.close();
            } else {
              dialog.removeAttribute(
                'open'
              );
            }
          }
        }
      );

      dialog.addEventListener(
        'close',
        () => {
          trigger.focus();
        }
      );
    }

    bindLocationDialog() {
      const trigger = this.root.querySelector(
        '[data-cs-location-dialog-open]'
      );

      if (!this.locationDialog || !trigger) return;

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        this.openLocationDialog(trigger);
      });

      this.locationDialog
        .querySelector('[data-cs-location-dialog-close]')
        ?.addEventListener('click', () => {
          this.closeLocationDialog();
        });

      this.locationDialog
        .querySelector('[data-cs-location-dialog-cancel]')
        ?.addEventListener('click', () => {
          this.closeLocationDialog();
        });

      this.locationDialog
        .querySelector('[data-cs-location-dialog-switch]')
        ?.addEventListener('click', async () => {
          await this.switchShopLocation();
        });

      this.locationDialog.addEventListener('click', (event) => {
        if (event.target === this.locationDialog) {
          this.closeLocationDialog();
        }
      });

      this.locationDialog.addEventListener('close', () => {
        this.pendingLocationHandle = '';
        this.locationSwitchInProgress = false;
        this.restoreLocationDialogFocus();
      });
    }

    getLocationChoices() {
      return this.fulfillmentOptions
        .filter(
          (option) =>
            option.fulfillment_category === 'pickup' &&
            ![
              'porch_pickup',
              'self_serve',
            ].includes(option.pickup_subtype)
        )
        .sort(
          (first, second) =>
            Number(first.sort_order ?? 999) -
            Number(second.sort_order ?? 999)
        );
    }

    shoppingPathForOption(option) {
      if (
        option?.pickup_subtype === 'bakehouse_order_ahead' ||
        option?.handle === 'cold-sugar-bakehouse-parmer-ranch'
      ) {
        return 'bakehouse_order_ahead';
      }

      return 'market_pickup';
    }

    getShopLocationPresentation(option) {
      const fallbackByHandle = {
        'cold-sugar-bakehouse-parmer-ranch': {
          icon: 'house',
          color: '#7EA8A6',
          tagline: 'Order ahead for pickup · 48+ hours ahead',
        },
        'parmer-ranch-park': {
          icon: 'tree',
          color: '#6F8F6A',
          tagline: 'A quick neighborhood market stop',
        },
        'arboretum-farmers-market': {
          icon: 'tent',
          color: '#2B3647',
          tagline: 'Fast, convenient, and easy to park',
        },
        'bee-cave-farmers-market': {
          icon: 'bee',
          color: '#BE9140',
          tagline: 'A relaxed Sunday market outing',
        },
      };

      const fallback =
        fallbackByHandle[option?.handle] || {
          icon: 'pin',
          color: '#2B3647',
          tagline: '',
        };

      const requestedColor = String(
        option?.marker_color || ''
      ).trim();

      return {
        icon: option?.location_icon || fallback.icon,
        color: /^#[0-9a-f]{6}$/i.test(requestedColor)
          ? requestedColor
          : fallback.color,
        tagline:
          option?.location_tagline ||
          fallback.tagline,
        badges: Array.isArray(option?.location_badges)
          ? option.location_badges
          : [],
      };
    }

    renderShopLocationIcon(iconKey) {
      const common =
        'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"';

      if (iconKey === 'house') {
        return `<svg ${common}><path d="M3 11.2 12 4l9 7.2"/><path d="M5.5 10.5V20h13v-9.5"/><path d="M9.5 20v-5.5h5V20"/></svg>`;
      }

      if (iconKey === 'tree') {
        return `<svg ${common}><path d="M12 21v-6"/><path d="M8.5 21h7"/><path d="M12 3 7.5 10h2.7L6.5 15h11l-3.7-5h2.7L12 3Z"/></svg>`;
      }

      if (iconKey === 'tent') {
        return `<svg ${common}><path d="M3 9h18"/><path d="m5 9 2-5h10l2 5"/><path d="M5 9v11h14V9"/><path d="M9 20v-7h6v7"/><path d="M8 4v5M12 4v5M16 4v5"/></svg>`;
      }

      if (
        iconKey === 'bee' ||
        iconKey === 'letter-b' ||
        iconKey === 'b'
      ) {
        return `<svg ${common}><path d="M7.4 12.6c0-2.6 2-4.6 4.6-4.6s4.6 2 4.6 4.6-2 4.6-4.6 4.6-4.6-2-4.6-4.6Z"/><path d="M9.2 9.1c-.8-2.1-2.6-3.2-4.2-2.3-1.5.9-.9 3.3 2.4 4.5M14.8 9.1c.8-2.1 2.6-3.2 4.2-2.3 1.5.9.9 3.3-2.4 4.5"/><path d="M9.4 9.1v7M12 8.1v9M14.6 9.1v7"/><path d="M7.4 12.6H4.5M16.6 12.6h2.9"/></svg>`;
      }

      return `<svg ${common}><path d="M20 10c0 5-8 11-8 11S4 15 4 10a8 8 0 1 1 16 0Z"/><circle cx="12" cy="10" r="2.5"/></svg>`;
    }

    renderLocationDialog() {
      if (!this.locationDialog) return;

      const optionsContainer =
        this.locationDialog.querySelector(
          '[data-cs-location-options]'
        );

      const switchButton =
        this.locationDialog.querySelector(
          '[data-cs-location-dialog-switch]'
        );

      if (!optionsContainer || !switchButton) return;

      const currentHandle =
        this.shoppingContext?.fulfillmentHandle || '';

      const choices = this.getLocationChoices();

      optionsContainer.innerHTML = choices
        .map((option) => {
          const presentation =
            this.getShopLocationPresentation(option);

          const isCurrent =
            option.handle === currentHandle;

          const isSelected =
            option.handle ===
            this.pendingLocationHandle;

          const displayName =
            option.pickup_subtype ===
            'bakehouse_order_ahead'
              ? 'Cold Sugar Bakehouse — Order Ahead'
              : option.display_name;

          const badges = presentation.badges.length
            ? `
              <span class="cs-shop__location-option-badges">
                ${presentation.badges
                  .map(
                    (badge) =>
                      `<span>${this.escapeHTML(badge)}</span>`
                  )
                  .join('')}
              </span>
            `
            : '';

          return `
            <div
              class="cs-shop__location-option${
                isCurrent ? ' is-current' : ''
              }${
                isSelected ? ' is-selected' : ''
              }"
              style="--cs-location-accent: ${
                presentation.color
              };"
            >
              <button
                class="cs-shop__location-option-select"
                type="button"
                data-cs-location-option="${this.escapeHTML(
                  option.handle
                )}"
                aria-pressed="${
                  isSelected ? 'true' : 'false'
                }"
                ${
                  this.locationSwitchInProgress
                    ? 'disabled'
                    : ''
                }
              >
                <span class="cs-shop__location-option-heading">
                <span class="cs-shop__location-option-icon">
                  ${this.renderShopLocationIcon(
                    presentation.icon
                  )}
                </span>

                <span class="cs-shop__location-option-title">
                  <strong>${this.escapeHTML(
                    displayName
                  )}</strong>
                  ${
                    option.city_state
                      ? `<small>${this.escapeHTML(
                          option.city_state
                        )}</small>`
                      : ''
                  }
                </span>

                ${
                  isCurrent
                    ? '<span class="cs-shop__location-option-status">Current</span>'
                    : isSelected
                      ? '<span class="cs-shop__location-option-status">Selected</span>'
                      : ''
                }
              </span>

              ${
                option.full_address
                  ? `
                    <span class="cs-shop__location-option-detail">
                      <b>Pickup address</b>
                      <span>${this.escapeHTML(
                        option.full_address
                      ).replace(/\n/g, '<br>')}</span>
                    </span>
                  `
                  : ''
              }

              ${
                option.display_schedule ||
                option.time_window
                  ? `
                    <span class="cs-shop__location-option-detail">
                      <b>Schedule</b>
                      <span>${this.escapeHTML(
                        option.display_schedule ||
                        option.time_window
                      )}</span>
                    </span>
                  `
                  : ''
              }

              ${
                presentation.tagline
                  ? `
                    <span class="cs-shop__location-option-tagline">
                      ${this.escapeHTML(
                        presentation.tagline
                      )}
                    </span>
                  `
                  : ''
              }

                ${badges}
              </button>

              ${
                isSelected && !isCurrent
                  ? `
                    <button
                      class="cs-shop__location-option-inline-switch"
                      type="button"
                      data-cs-location-inline-switch
                      ${
                        this.locationSwitchInProgress
                          ? 'disabled'
                          : ''
                      }
                    >
                      ${
                        this.locationSwitchInProgress
                          ? 'Switching location…'
                          : `Switch to ${
                              option.pickup_subtype ===
                              'bakehouse_order_ahead'
                                ? 'Bakehouse Order Ahead'
                                : option.display_name
                            }`
                      }
                    </button>
                  `
                  : ''
              }
            </div>
          `;
        })
        .join('');

      optionsContainer
        .querySelectorAll('[data-cs-location-option]')
        .forEach((button) => {
          button.addEventListener('click', () => {
            if (this.locationSwitchInProgress) return;

            this.pendingLocationHandle =
              button.getAttribute(
                'data-cs-location-option'
              ) || '';

            this.clearLocationDialogError();
            this.renderLocationDialog();
          });
        });

      optionsContainer
        .querySelector('[data-cs-location-inline-switch]')
        ?.addEventListener('click', async () => {
          await this.switchShopLocation();
        });

      const selectedOption = choices.find(
        (option) =>
          option.handle ===
          this.pendingLocationHandle
      );

      const hasChanged =
        Boolean(selectedOption) &&
        selectedOption.handle !== currentHandle;

      switchButton.disabled =
        !hasChanged ||
        this.locationSwitchInProgress;

      switchButton.textContent = this.locationSwitchInProgress
        ? 'Switching location…'
        : hasChanged
          ? `Switch to ${
              selectedOption.pickup_subtype ===
              'bakehouse_order_ahead'
                ? 'Bakehouse Order Ahead'
                : selectedOption.display_name
            }`
          : 'Choose another location';
    }

    openLocationDialog(trigger = null) {
      if (!this.locationDialog) return;

      this.locationDialogTrigger =
        trigger instanceof HTMLElement
          ? trigger
          : document.activeElement;

      this.pendingLocationHandle =
        this.shoppingContext?.fulfillmentHandle || '';

      this.locationSwitchInProgress = false;
      this.clearLocationDialogError();
      this.renderLocationDialog();

      if (
        typeof this.locationDialog.showModal ===
        'function'
      ) {
        this.locationDialog.showModal();
      } else {
        this.locationDialog.setAttribute('open', '');
      }

      window.requestAnimationFrame(() => {
        this.locationDialog
          ?.querySelector(
            `[data-cs-location-option="${this.escapeSelector(
              this.pendingLocationHandle
            )}"]`
          )
          ?.focus();
      });
    }

    closeLocationDialog() {
      if (
        !this.locationDialog ||
        this.locationSwitchInProgress
      ) {
        return;
      }

      if (
        typeof this.locationDialog.close ===
          'function' &&
        this.locationDialog.open
      ) {
        this.locationDialog.close();
      } else {
        this.locationDialog.removeAttribute('open');
        this.restoreLocationDialogFocus();
      }
    }

    restoreLocationDialogFocus() {
      if (
        this.locationDialogTrigger instanceof
        HTMLElement
      ) {
        this.locationDialogTrigger.focus();
      }

      this.locationDialogTrigger = null;
    }

    clearLocationDialogError() {
      const error =
        this.locationDialog?.querySelector(
          '[data-cs-location-dialog-error]'
        );

      if (!error) return;

      error.textContent = '';
      error.hidden = true;
    }

    showLocationDialogError(message) {
      const error =
        this.locationDialog?.querySelector(
          '[data-cs-location-dialog-error]'
        );

      if (!error) return;

      error.textContent = message;
      error.hidden = false;
    }

    setLocationDialogLoading(isLoading) {
      if (!this.locationDialog) return;

      this.locationSwitchInProgress =
        Boolean(isLoading);

      this.locationDialog
        .querySelectorAll('button')
        .forEach((button) => {
          button.disabled =
            this.locationSwitchInProgress;
        });

      this.locationDialog.setAttribute(
        'aria-busy',
        String(this.locationSwitchInProgress)
      );

      this.renderLocationDialog();
    }

    async switchShopLocation() {
      if (
        !this.locationDialog ||
        this.locationSwitchInProgress
      ) {
        return;
      }

      const option = this.getLocationChoices().find(
        (item) =>
          item.handle ===
          this.pendingLocationHandle
      );

      if (
        !option ||
        option.handle ===
          this.shoppingContext?.fulfillmentHandle
      ) {
        return;
      }

      const shoppingPath =
        this.shoppingPathForOption(option);

      this.clearLocationDialogError();
      this.setLocationDialogLoading(true);

      try {
        let cart = await this.fetchCart();
        const cartMode =
          this.determineCartMode(cart);

        if (cartMode === 'local') {
          cart =
            await this.migrateLocalCartToShoppingPath(
              cart,
              option,
              shoppingPath
            );
        }

        this.shoppingContext = {
          shoppingPath,
          fulfillmentHandle: option.handle,
          option,
        };

        try {
          sessionStorage.setItem(
            'coldSugarShoppingContext',
            JSON.stringify({
              shoppingPath,
              fulfillmentHandle: option.handle,
              savedAt: Date.now(),
            })
          );
        } catch (error) {
          console.warn(
            'Cold Sugar shopping context could not be saved.',
            error
          );
        }

        const url = new URL(window.location.href);
        url.searchParams.set('gateway', 'skip');
        url.searchParams.set('mode', 'local');
        url.searchParams.set(
          'shopping_path',
          shoppingPath
        );
        url.searchParams.set(
          'fulfillment',
          option.handle
        );

        window.history.replaceState({}, '', url);

        this.setMode('local', {
          updateUrl: false,
        });

        this.renderShoppingContext();
        this.updateVisibleCartCount(cart);

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart },
          })
        );

        this.locationSwitchInProgress = false;

        if (
          typeof this.locationDialog.close ===
            'function' &&
          this.locationDialog.open
        ) {
          this.locationDialog.close();
        } else {
          this.locationDialog.removeAttribute(
            'open'
          );
          this.restoreLocationDialogFocus();
        }
      } catch (error) {
        this.setLocationDialogLoading(false);
        this.showLocationDialogError(
          error.message ||
            'We could not switch your order location. Please try again.'
        );
      }
    }

    bindQuickAddForm(form) {
      const minus =
        form.querySelector(
          '[data-quantity-minus]'
        );

      const plus =
        form.querySelector(
          '[data-quantity-plus]'
        );

      const input =
        form.querySelector(
          '[data-quantity-input]'
        );

      const select =
        form.querySelector(
          '[data-variant-select]'
        );

      const queueTarget = (
        rawValue,
        {
          immediate = false
        } = {}
      ) => {
        if (!input) return;

        const target =
          this.normalizeLiveCartTarget(
            form,
            rawValue
          );

        input.value =
          String(target);

        form.dataset.csDesiredQuantity =
          String(target);

        this.clearFormError(form);

        this.scheduleLiveCartQuantityCommit(
          form,
          {
            immediate
          }
        );
      };

      minus?.addEventListener(
        'click',
        () => {
          if (!input) return;

          const meta =
            this.getVariantMeta(form);

          const current =
            Math.max(
              0,
              Number(input.value) || 0
            );

          if (current <= 0) {
            return;
          }

          const next =
            current <= meta.min
              ? 0
              : Math.max(
                  meta.min,
                  current -
                    meta.increment
                );

          queueTarget(next);
        }
      );

      plus?.addEventListener(
        'click',
        () => {
          if (!input) return;

          const meta =
            this.getVariantMeta(form);

          if (!meta.available) {
            return;
          }

          const current =
            Math.max(
              0,
              Number(input.value) || 0
            );

          let next =
            current === 0
              ? meta.min
              : current +
                meta.increment;

          if (meta.max) {
            next =
              Math.min(
                meta.max,
                next
              );
          }

          queueTarget(next);
        }
      );

      input?.addEventListener(
        'focus',
        () => {
          window.requestAnimationFrame(
            () => {
              input.select();
            }
          );
        }
      );

      input?.addEventListener(
        'input',
        () => {
          /*
            Let the customer briefly clear the field while
            typing a replacement value such as 10.
          */
          if (input.value === '') {
            return;
          }

          queueTarget(
            input.value
          );
        }
      );

      input?.addEventListener(
        'blur',
        () => {
          if (input.value === '') {
            input.value =
              input.dataset
                .lastCommittedQuantity ||
              '0';
          }

          queueTarget(
            input.value,
            {
              immediate: true
            }
          );
        }
      );

      input?.addEventListener(
        'keydown',
        (event) => {
          if (
            event.key !== 'Enter'
          ) {
            return;
          }

          event.preventDefault();

          if (input.value === '') {
            input.value =
              input.dataset
                .lastCommittedQuantity ||
              '0';
          }

          queueTarget(
            input.value,
            {
              immediate: true
            }
          );

          input.blur();
        }
      );

      select?.addEventListener(
        'change',
        () => {
          this.cancelLiveCartQuantityCommit(
            form
          );

          this.updateVariantState(form);

          void this
            .syncQuickAddForm(form)
            .catch((error) => {
              console.error(
                'Cold Sugar variant cart quantity sync failed:',
                error
              );
            });
        }
      );

      /*
        This control edits the live cart directly.
        There is intentionally no separate submit action.
      */
      form.addEventListener(
        'submit',
        (event) => {
          event.preventDefault();

          queueTarget(
            input?.value || 0,
            {
              immediate: true
            }
          );
        }
      );

      this.updateVariantState(form);
    }


    getQuickAddCartLine(cart, form) {
      const meta =
        this.getVariantMeta(form);

      const wrapper =
        form.closest(
          '[data-cs-quick-add]'
        );

      const orderMode =
        this.normalizeMode(
          wrapper?.dataset.orderMode
        );

      const shippingPackType =
        String(
          wrapper?.dataset
            .shippingPackType ||
          ''
        )
          .trim()
          .toLowerCase();

      const shoppingPath =
        String(
          this.shoppingContext
            ?.shoppingPath ||
          ''
        )
          .trim()
          .toLowerCase();

      return (
        cart?.items || []
      ).find((item) => {
        if (this.isPickupLock(item)) {
          return false;
        }

        const variantId =
          Number(
            item.variant_id ||
            item.id ||
            0
          );

        if (variantId !== meta.id) {
          return false;
        }

        const properties =
          item.properties || {};

        const itemMode =
          this.normalizeMode(
            properties
              ._cold_sugar_order_mode
          );

        if (itemMode !== orderMode) {
          return false;
        }

        if (
          orderMode === 'shipping' &&
          shippingPackType
        ) {
          const itemPackType =
            String(
              properties
                ._cold_sugar_shipping_pack_type ||
              ''
            )
              .trim()
              .toLowerCase();

          if (
            itemPackType !==
            shippingPackType
          ) {
            return false;
          }
        }

        if (
          orderMode === 'local' &&
          shoppingPath
        ) {
          const linePath =
            String(
              properties
                ._cold_sugar_shopping_path ||
              ''
            )
              .trim()
              .toLowerCase();

          if (
            linePath &&
            linePath !==
              shoppingPath
          ) {
            return false;
          }
        }

        return true;
      }) || null;
    }

    async syncQuickAddForm(
      form,
      cartState = null
    ) {
      const cart =
        cartState?.items
          ? cartState
          : await this.fetchCart();

      const line =
        this.getQuickAddCartLine(
          cart,
          form
        );

      const input =
        form.querySelector(
          '[data-quantity-input]'
        );

      const cartQuantity =
        Number(
          line?.quantity ||
          0
        );

      if (input) {
        input.value =
          String(
            cartQuantity
          );

        input.dataset.cartLineKey =
          line?.key || '';

        input.dataset.lastCommittedQuantity =
          String(
            cartQuantity
          );

        form.dataset.csDesiredQuantity =
          String(
            cartQuantity
          );
      }

      this.updateQuickAddCartConfirmation(
        form,
        cartQuantity
      );

      this.updateVariantState(form);

      return line;
    }

    async syncQuickAddControls(
      cartState = null
    ) {
      const cart =
        cartState?.items
          ? cartState
          : await this.fetchCart();

      const forms =
        Array.from(
          this.root.querySelectorAll(
            '[data-cs-quick-add-form]'
          )
        );

      await Promise.all(
        forms.map(
          (form) =>
            this.syncQuickAddForm(
              form,
              cart
            )
        )
      );

      return cart;
    }

    normalizeLiveCartTarget(
      form,
      rawValue
    ) {
      const input =
        form.querySelector(
          '[data-quantity-input]'
        );

      const meta =
        this.getVariantMeta(form);

      const fallback =
        Math.max(
          0,
          Number(
            input?.dataset
              .lastCommittedQuantity ||
            0
          ) || 0
        );

      let value =
        Number.parseInt(
          String(
            rawValue ?? ''
          ),
          10
        );

      if (
        !Number.isFinite(value)
      ) {
        return fallback;
      }

      if (value <= 0) {
        return 0;
      }

      value =
        Math.max(
          meta.min,
          value
        );

      const steps =
        Math.round(
          (
            value -
            meta.min
          ) /
          meta.increment
        );

      value =
        meta.min +
        steps *
          meta.increment;

      if (meta.max) {
        value =
          Math.min(
            meta.max,
            value
          );
      }

      return value;
    }

    cancelLiveCartQuantityCommit(
      form
    ) {
      if (
        form._csQuantityCommitTimer
      ) {
        window.clearTimeout(
          form._csQuantityCommitTimer
        );

        form._csQuantityCommitTimer =
          null;
      }
    }

    scheduleLiveCartQuantityCommit(
      form,
      {
        immediate = false
      } = {}
    ) {
      this.cancelLiveCartQuantityCommit(
        form
      );

      const commit = () => {
        form._csQuantityCommitTimer =
          null;

        void this
          .commitLiveCartQuantity(
            form
          )
          .catch((error) => {
            console.error(
              'Cold Sugar live quantity commit failed:',
              error
            );
          });
      };

      if (immediate) {
        commit();
        return;
      }

      form._csQuantityCommitTimer =
        window.setTimeout(
          commit,
          500
        );
    }

    async commitLiveCartQuantity(
      form
    ) {
      const input =
        form.querySelector(
          '[data-quantity-input]'
        );

      if (!input) {
        return;
      }

      if (
        form.dataset
          .csQuantityCommitBusy ===
        'true'
      ) {
        form.dataset
          .csQuantityCommitQueued =
          'true';

        return;
      }

      let target =
        this.normalizeLiveCartTarget(
          form,
          form.dataset
            .csDesiredQuantity ??
          input.value
        );

      const confirmed =
        Math.max(
          0,
          Number(
            input.dataset
              .lastCommittedQuantity ||
            0
          ) || 0
        );

      input.value =
        String(target);

      form.dataset.csDesiredQuantity =
        String(target);

      if (
        target === confirmed
      ) {
        return;
      }

      form.dataset
        .csQuantityCommitBusy =
        'true';

      this.clearFormError(form);

      try {
        const meta =
          this.getVariantMeta(form);

        if (
          target > 0 &&
          !meta.available
        ) {
          throw new Error(
            'This item is currently sold out.'
          );
        }

        const wrapper =
          form.closest(
            '[data-cs-quick-add]'
          );

        const orderMode =
          this.normalizeMode(
            wrapper?.dataset.orderMode
          );

        const shippingPackType =
          String(
            wrapper?.dataset
              .shippingPackType ||
            ''
          )
            .trim()
            .toLowerCase();

        let cart =
          await this.fetchCart();

        const line =
          this.getQuickAddCartLine(
            cart,
            form
          );

        const currentQuantity =
          Math.max(
            0,
            Number(
              line?.quantity ||
              0
            )
          );

        if (
          target ===
          currentQuantity
        ) {
          input.dataset
            .lastCommittedQuantity =
            String(target);

          this.updateQuickAddCartConfirmation(
            form,
            target
          );

          return;
        }

        /*
          Any shipping quantity edit must pass through the
          same nationwide box-capacity engine before Shopify
          receives the cart change.
        */
        if (
          orderMode === 'shipping' &&
          target > 0
        ) {
          const shippingBox =
            window
              .ColdSugarShippingBox;

          if (
            !shippingBox
          ) {
            throw new Error(
              'Shipping box protection is still loading. Please wait a moment and try again.'
            );
          }

          if (
            !shippingPackType
          ) {
            throw new Error(
              'This shipped item is missing its box-packing information.'
            );
          }

          let result =
            line
              ? shippingBox
                  .previewLineQuantity(
                    cart.items || [],
                    line.key,
                    target
                  )
              : shippingBox
                  .previewAdd(
                    cart.items || [],
                    shippingPackType,
                    target
                  );

          /*
            If the customer asks for more than can fit,
            keep as much of that quantity as the current
            nationwide order can legally hold.
          */
          if (
            !result.valid &&
            target > currentQuantity
          ) {
            for (
              let candidate =
                target - meta.increment;
              candidate > currentQuantity;
              candidate -= meta.increment
            ) {
              const candidateResult =
                line
                  ? shippingBox
                      .previewLineQuantity(
                        cart.items || [],
                        line.key,
                        candidate
                      )
                  : shippingBox
                      .previewAdd(
                        cart.items || [],
                        shippingPackType,
                        candidate
                      );

              if (candidateResult.valid) {
                target = candidate;
                result = candidateResult;

                input.value =
                  String(candidate);

                form.dataset.csDesiredQuantity =
                  String(candidate);

                break;
              }
            }
          }

          if (!result.valid) {
            throw new Error(
              result.message ||
              'That quantity will not fit in the available shipping boxes.'
            );
          }
        }

        if (target <= 0) {
          if (line) {
            await this.changeShopCartLine(
              form,
              line.key,
              0
            );
          }
        } else if (line) {
          await this.changeShopCartLine(
            form,
            line.key,
            target
          );
        } else {
          await this.handleQuickAdd(
            form,
            {
              quantityOverride:
                target,
              trigger:
                form.querySelector(
                  '[data-quantity-plus]'
                ),
              openCartUi: false
            }
          );
        }

        cart =
          await this.fetchCart();

        await this.syncQuickAddForm(
          form,
          cart
        );
      } catch (error) {
        const lastConfirmed =
          Math.max(
            0,
            Number(
              input.dataset
                .lastCommittedQuantity ||
              0
            ) || 0
          );

        input.value =
          String(
            lastConfirmed
          );

        form.dataset.csDesiredQuantity =
          String(
            lastConfirmed
          );

        this.updateQuickAddCartConfirmation(
          form,
          lastConfirmed
        );

        this.showFormError(
          form,
          error.message ||
          'We could not update this quantity. Please try again.'
        );
      } finally {
        delete form.dataset
          .csQuantityCommitBusy;

        if (
          form.dataset
            .csQuantityCommitQueued ===
          'true'
        ) {
          delete form.dataset
            .csQuantityCommitQueued;

          this.scheduleLiveCartQuantityCommit(
            form,
            {
              immediate: true
            }
          );
        }
      }
    }

    async adjustLiveCartQuantity(
      form,
      direction
    ) {
      if (
        form.dataset
          .liveCartBusy ===
        'true'
      ) {
        return;
      }

      form.dataset.liveCartBusy =
        'true';

      this.clearFormError(form);

      try {
        const meta =
          this.getVariantMeta(form);

        if (
          direction > 0 &&
          !meta.available
        ) {
          return;
        }

        const cart =
          await this.fetchCart();

        const line =
          this.getQuickAddCartLine(
            cart,
            form
          );

        const currentQuantity =
          Number(
            line?.quantity ||
            0
          );

        if (direction > 0) {
          if (
            meta.max &&
            currentQuantity >= meta.max
          ) {
            return;
          }

          /*
            First click respects Shopify's minimum.
            Later clicks use the variant's increment.
          */
          let addQuantity =
            currentQuantity === 0
              ? meta.min
              : meta.increment;

          if (
            meta.max &&
            currentQuantity +
              addQuantity >
              meta.max
          ) {
            addQuantity =
              meta.max -
              currentQuantity;
          }

          if (addQuantity <= 0) {
            return;
          }

          await this.handleQuickAdd(
            form,
            {
              quantityOverride:
                addQuantity,
              trigger:
                form.querySelector(
                  '[data-quantity-plus]'
                ),
              openCartUi: false
            }
          );

          return;
        }

        if (
          !line ||
          currentQuantity <= 0
        ) {
          return;
        }

        const nextQuantity =
          currentQuantity <= meta.min
            ? 0
            : Math.max(
                meta.min,
                currentQuantity -
                  meta.increment
              );

        await this.changeShopCartLine(
          form,
          line.key,
          nextQuantity
        );
      } catch (error) {
        this.showFormError(
          form,
          error.message ||
            'We could not update this item. Please try again.'
        );
      } finally {
        delete form.dataset
          .liveCartBusy;
      }
    }

    async changeShopCartLine(
      form,
      itemKey,
      quantity
    ) {
      this.setFormLoading(
        form,
        true
      );

      try {
        const response =
          await fetch(
            this.route(
              'cart/change.js'
            ),
            {
              method: 'POST',
              headers: {
                Accept:
                  'application/json',
                'Content-Type':
                  'application/json',
                'X-Requested-With':
                  'XMLHttpRequest',
              },
              body:
                JSON.stringify({
                  id: itemKey,
                  quantity
                }),
            }
          );

        const result =
          await response.json();

        if (
          !response.ok ||
          result.status
        ) {
          throw new Error(
            result.description ||
            result.message ||
            'We could not update this item.'
          );
        }

        /*
          If that was the last real local item, reuse the
          existing cleanup that removes the hidden pickup lock
          and clears stale fulfillment attributes.
        */
        await this
          .cleanupNotificationCartIfEmpty(
            result
          );

        const cartUi =
          document.querySelector(
            'cart-drawer'
          ) ||
          document.querySelector(
            'cart-notification'
          );

        await this.refreshCartUi(
          cartUi,
          {
            openCartUi: false,
            expandShopDock: true
          }
        );

        this.showAddedState(form);
      } finally {
        this.setFormLoading(
          form,
          false
        );
      }
    }

    updateQuickAddCartConfirmation(
      form,
      quantity
    ) {
      const confirmation =
        form.querySelector(
          '[data-cart-confirmation]'
        );

      if (!confirmation) {
        return;
      }

      const count =
        Math.max(
          0,
          Number(quantity) || 0
        );

      if (count <= 0) {
        confirmation.textContent = '';
        confirmation.hidden = true;
        return;
      }

      confirmation.textContent =
        `✓ ${count} in cart`;

      confirmation.hidden = false;
    }

    visibleCartItemCount(cart) {
      return (
        cart?.items || []
      ).reduce(
        (total, item) => {
          if (this.isPickupLock(item)) {
            return total;
          }

          return (
            total +
            Number(
              item.quantity || 0
            )
          );
        },
        0
      );
    }

    localDockContextLabel() {
      const option =
        this.shoppingContext
          ?.option;

      if (!option) {
        return 'Ready when you are.';
      }

      if (
        option.pickup_subtype ===
        'bakehouse_order_ahead'
      ) {
        return (
          'Pickup: Cold Sugar Bakehouse — Order Ahead'
        );
      }

      const label =
        option.display_name ||
        option.city_state ||
        '';

      return label
        ? `Pickup: ${label}`
        : 'Ready when you are.';
    }

    renderLocalCartDock(
      cart,
      {
        expand = false
      } = {}
    ) {
      const dock =
        this.root.querySelector(
          '[data-cs-local-cart-dock]'
        );

      if (!dock) {
        return;
      }

      const cartMode =
        this.determineCartMode(
          cart
        );

      const count =
        this.visibleCartItemCount(
          cart
        );

      if (
        this.activeMode !== 'local' ||
        cartMode !== 'local' ||
        count <= 0
      ) {
        dock.hidden = true;

        dock.classList.remove(
          'is-expanded',
          'is-collapsed'
        );

        return;
      }

      dock.hidden = false;

      const title =
        dock.querySelector(
          '[data-cs-local-cart-dock-title]'
        );

      const copy =
        dock.querySelector(
          '[data-cs-local-cart-dock-copy]'
        );

      const countNode =
        dock.querySelector(
          '[data-cs-local-cart-dock-count]'
        );

      if (title) {
        title.textContent =
          `${count} ${
            count === 1
              ? 'item'
              : 'items'
          } in your cart`;
      }

      if (copy) {
        copy.textContent =
          this.localDockContextLabel();
      }

      if (countNode) {
        countNode.textContent =
          `· ${count}`;
      }

      if (
        !dock.classList.contains(
          'is-expanded'
        ) &&
        !dock.classList.contains(
          'is-collapsed'
        )
      ) {
        dock.classList.add(
          'is-expanded'
        );
      }

      if (expand) {
        this.expandActiveShopDock();
      }
    }

    getActiveShopDock() {
      if (
        this.activeMode ===
        'shipping'
      ) {
        return this.root.querySelector(
          '[data-cs-shipping-box-dock]'
        );
      }

      return this.root.querySelector(
        '[data-cs-local-cart-dock]'
      );
    }

    expandActiveShopDock() {
      const dock =
        this.getActiveShopDock();

      if (
        !dock ||
        dock.hidden
      ) {
        return;
      }

      dock.classList.remove(
        'is-collapsed'
      );

      dock.classList.add(
        'is-expanded'
      );

      this.shopDockExpandedAtY =
        window.scrollY;
    }

    collapseActiveShopDock() {
      const dock =
        this.getActiveShopDock();

      if (
        !dock ||
        dock.hidden ||
        dock.classList.contains(
          'is-collapsed'
        )
      ) {
        return;
      }

      dock.classList.remove(
        'is-expanded'
      );

      dock.classList.add(
        'is-collapsed'
      );
    }

    bindShopDockBehavior() {
      let queued = false;

      window.addEventListener(
        'scroll',
        () => {
          if (queued) {
            return;
          }

          queued = true;

          window.requestAnimationFrame(
            () => {
              queued = false;

              const distance =
                Math.abs(
                  window.scrollY -
                  this.shopDockExpandedAtY
                );

              if (
                distance >= 48
              ) {
                this.collapseActiveShopDock();
              }
            }
          );
        },
        {
          passive: true
        }
      );
    }

    bindDialog() {
      if (!this.dialog) return;

      this.dialog.querySelector('[data-cs-dialog-close]')?.addEventListener('click', () => {
        this.closeModeDialog();
      });

      this.dialog.querySelector('[data-cs-dialog-keep]')?.addEventListener('click', () => {
        this.keepCurrentOrder();
      });

      this.dialog.querySelector('[data-cs-dialog-switch]')?.addEventListener('click', async () => {
        await this.confirmModeSwitch();
      });

      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          this.closeModeDialog();
        }
      });

      this.dialog.addEventListener('close', () => {
        this.restoreDialogFocus();
      });
    }

    loadInitialState() {
      const params = new URLSearchParams(window.location.search);
      const requestedMode = params.get('mode');
      const initialMode = this.panels.some((panel) => panel.dataset.shopPanel === requestedMode)
        ? requestedMode
        : this.defaultMode;

      this.setMode(initialMode, { updateUrl: false });
      this.renderShoppingContext();

      void this
        .syncQuickAddControls()
        .then((cart) => {
          this.renderLocalCartDock(
            cart
          );
        })
        .catch((error) => {
          console.error(
            'Cold Sugar initial Shop cart quantity sync failed:',
            error
          );
        });

      const category = params.get('category');
      const activePanel = this.getPanel(initialMode);

      if (
        activePanel &&
        category &&
        activePanel.querySelector(`[data-shop-category="${this.escapeSelector(category)}"]`)
      ) {
        this.applyCategory(activePanel, category, { updateUrl: false });
      } else if (activePanel) {
        this.applyCategory(activePanel, 'all', { updateUrl: false });
      }

      window.ColdSugarShippingBoxUI
        ?.refresh()
        .catch((error) => {
          console.error(
            'Cold Sugar initial shipping box guide load failed:',
            error
          );
        });
    }

    setMode(mode, { updateUrl = false } = {}) {
      if (!['local', 'shipping'].includes(mode)) return;

      this.activeMode = mode;

      const shippingActive =
        mode === 'shipping';

      this.root.classList.toggle(
        'is-shipping-active',
        shippingActive
      );

      document.body.classList.toggle(
        'cs-shop-shipping-active',
        shippingActive
      );

      this.tabs.forEach((tab) => {
        const isActive = tab.dataset.shopMode === mode;
        tab.setAttribute('aria-selected', String(isActive));
        tab.tabIndex = isActive ? 0 : -1;
      });

      this.panels.forEach((panel) => {
        panel.hidden = panel.dataset.shopPanel !== mode;
      });

      const activePanel = this.getPanel(mode);
      if (activePanel) {
        this.applyCategory(activePanel, 'all', { updateUrl: false });
      }

      this.updateMerchButtonLabel(mode);

      if (updateUrl) {
        this.updateUrl({ mode, category: null });
      }
    }

    updateMerchButtonLabel(mode) {
      const button = this.root.querySelector('[data-shop-jump-current]');
      if (!button) return;

      const context =
        mode === 'shipping'
          ? 'shipped nationwide'
          : 'available for local pickup or delivery';

      button.setAttribute('aria-label', `Shop merch ${context}`);
    }

    applyCategory(panel, category, { updateUrl = false } = {}) {
      if (!panel) return;

      const buttons = Array.from(panel.querySelectorAll('[data-shop-category]'));
      const products = Array.from(panel.querySelectorAll('[data-shop-product]'));
      const validCategory = buttons.some((button) => button.dataset.shopCategory === category)
        ? category
        : 'all';

      buttons.forEach((button) => {
        const isActive = button.dataset.shopCategory === validCategory;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      let visibleCount = 0;

      products.forEach((product) => {
        const shouldShow =
          validCategory === 'all' || product.dataset.category === validCategory;

        product.hidden = !shouldShow;
        if (shouldShow) visibleCount += 1;
      });

      const count = panel.querySelector('[data-shop-count]');
      if (count) {
        count.textContent = `${visibleCount} ${visibleCount === 1 ? 'item' : 'items'}`;
      }

      if (updateUrl) {
        this.updateUrl({
          mode: panel.dataset.shopPanel,
          category: validCategory === 'all' ? null : validCategory,
        });
      }
    }

    getPanel(mode) {
      return this.panels.find((panel) => panel.dataset.shopPanel === mode);
    }

    getVariantControl(form) {
      return form.querySelector('[data-variant-select]') ||
        form.querySelector('[data-variant-input]');
    }

    getVariantMeta(form) {
      const select = form.querySelector('[data-variant-select]');
      const source = select ? select.options[select.selectedIndex] : this.getVariantControl(form);

      if (!source) {
        throw new Error('No purchasable variant was found for this product.');
      }

      return {
        id: Number(source.value),
        available: source.dataset.available === 'true',
        min: Math.max(1, Number(source.dataset.min) || 1),
        max: source.dataset.max ? Number(source.dataset.max) : null,
        increment: Math.max(1, Number(source.dataset.increment) || 1),
      };
    }

    updateVariantState(form) {
      const meta =
        this.getVariantMeta(form);

      const input =
        form.querySelector(
          '[data-quantity-input]'
        );

      const minus =
        form.querySelector(
          '[data-quantity-minus]'
        );

      const plus =
        form.querySelector(
          '[data-quantity-plus]'
        );

      const current =
        Math.max(
          0,
          Number(
            input?.value ||
            0
          )
        );

      if (input) {
        input.min = '0';
        input.step =
          String(
            meta.increment
          );

        if (meta.max) {
          input.max =
            String(
              meta.max
            );
        } else {
          input.removeAttribute(
            'max'
          );
        }
      }

      if (minus) {
        minus.disabled =
          current <= 0;
      }

      if (plus) {
        plus.disabled =
          !meta.available ||
          Boolean(
            meta.max &&
            current >= meta.max
          );
      }

      form.classList.toggle(
        'is-sold-out',
        !meta.available
      );

      this.clearFormError(form);
    }

    changeQuantity(form, direction) {
      const input = form.querySelector('[data-quantity-input]');
      const meta = this.getVariantMeta(form);
      if (!input) return;

      const current = Number(input.value) || meta.min;
      input.value = String(current + direction * meta.increment);
      this.normalizeQuantity(form);
    }

    normalizeQuantity(form) {
      const input = form.querySelector('[data-quantity-input]');
      const meta = this.getVariantMeta(form);
      if (!input) return meta.min;

      let value = Number(input.value);
      if (!Number.isFinite(value)) value = meta.min;

      value = Math.max(meta.min, value);

      const stepsFromMinimum = Math.round((value - meta.min) / meta.increment);
      value = meta.min + stepsFromMinimum * meta.increment;

      if (meta.max) value = Math.min(meta.max, value);

      input.value = String(value);
      return value;
    }

    async handleQuickAdd(
      form,
      {
        quantityOverride = null,
        trigger = null,
        openCartUi = true
      } = {}
    ) {
      const button =
        trigger ||
        form.querySelector(
          '[data-quantity-plus]'
        ) ||
        form.querySelector(
          '[data-add-button]'
        );

      const meta =
        this.getVariantMeta(form);

      const quantity =
        quantityOverride == null
          ? this.normalizeQuantity(form)
          : Math.max(
              1,
              Number(
                quantityOverride
              ) || 1
            );
      const wrapper = form.closest('[data-cs-quick-add]');
      const orderMode = this.normalizeMode(wrapper?.dataset.orderMode);
      const shippingPackType = String(
        wrapper?.dataset.shippingPackType || ''
      ).trim().toLowerCase();

      if (!meta.available || button?.disabled) return;

      if (!orderMode) {
        this.showFormError(form, 'This product needs an Order mode before it can be added.');
        return;
      }

      this.clearFormError(form);

      try {
        if (
          !window.ColdSugarOrderMode ||
          typeof window.ColdSugarOrderMode.beforeAnyAdd !== 'function'
        ) {
          throw new Error(
            'Cart protection is still loading. Please wait a moment and try again.'
          );
        }

        const mayContinue =
          await window.ColdSugarOrderMode.beforeAnyAdd({
            trigger: button,
          });

        if (!mayContinue) {
          return;
        }
      } catch (error) {
        this.showFormError(
          form,
          error.message ||
            'Your cart could not be checked. Please try again.'
        );
        return;
      }

      this.setFormLoading(form, true);

      const pending = {
        variantId: meta.id,
        quantity,
        orderMode,
        shippingPackType,
        form,
        productTitle: wrapper?.dataset.productTitle || 'this item',
        openCartUi,
      };

      try {
        let cart =
          await this.fetchCart();

        const targetShoppingPath =
          this.shoppingContext
            ?.shoppingPath ||
          '';

        const shouldMigrateLocalCart =
          orderMode === 'local' &&
          [
            'bakehouse_order_ahead',
            'market_pickup',
          ].includes(
            targetShoppingPath
          ) &&
          (
            this.cartHasShoppingPath(
              cart,
              'porch_live'
            ) ||
            this.cartHasDifferentFixedLocalPath(
              cart,
              targetShoppingPath
            )
          );

        if (shouldMigrateLocalCart) {
          const option =
            this.getSelectedFulfillmentOption();

          cart =
            await this
              .migrateLocalCartToShoppingPath(
                cart,
                option,
                targetShoppingPath
              );
        }

        const cartMode =
          this.determineCartMode(cart);

        if (
          cartMode === 'empty' ||
          cartMode === orderMode
        ) {
          await this.addPendingItem(
            pending,
            cart
          );
          return;
        }

        this.setFormLoading(form, false);
        this.openModeDialog(cartMode, pending);
      } catch (error) {
        this.setFormLoading(form, false);
        this.showFormError(form, error.message || 'Something went wrong. Please try again.');
      }
    }

    parseModeMap() {
      const script = this.root.querySelector('[data-cs-order-mode-map]');
      if (!script) return {};

      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        console.error('Cold Sugar shop mode map could not be read.', error);
        return {};
      }
    }

    parseFulfillmentOptions() {
      const script = this.root.querySelector('[data-cs-shop-fulfillment-options]');
      if (!script) return [];

      try {
        return JSON.parse(script.textContent || '[]').map((option) => ({
          ...option,
          handle: String(option.handle || ''),
          fulfillment_category: String(option.fulfillment_category || '').trim().toLowerCase(),
          pickup_subtype: String(option.pickup_subtype || '').trim().toLowerCase(),
          pickup_lock_variant_id: option.pickup_lock_variant_id
            ? String(option.pickup_lock_variant_id)
            : '',
        }));
      } catch (error) {
        console.error('Cold Sugar fulfillment options could not be read.', error);
        return [];
      }
    }

    resolveShoppingContext() {
      const params = new URLSearchParams(window.location.search);
      const path = String(params.get('shopping_path') || '').trim().toLowerCase();
      const handle = String(params.get('fulfillment') || '').trim();

      if (!path || !handle) {
        try {
          sessionStorage.removeItem('coldSugarShoppingContext');
        } catch (error) {
          // Storage can be unavailable in strict browsing modes.
        }
        return null;
      }

      const option = this.fulfillmentOptions.find((item) => item.handle === handle) || null;
      if (!option) return null;

      const context = { shoppingPath: path, fulfillmentHandle: handle, option };

      try {
        sessionStorage.setItem(
          'coldSugarShoppingContext',
          JSON.stringify({ shoppingPath: path, fulfillmentHandle: handle, savedAt: Date.now() })
        );
      } catch (error) {
        console.warn('Cold Sugar shopping context could not be saved.', error);
      }

      return context;
    }

    renderShoppingContext() {
      const banner = this.root.querySelector(
        '[data-cs-shop-context]'
      );

      if (!banner) return;

      const context = this.shoppingContext;

      const fixedLocalPaths = new Set([
        'market_pickup',
        'bakehouse_order_ahead',
      ]);

      const isFixedLocalContext = Boolean(
        context &&
        fixedLocalPaths.has(
          context.shoppingPath
        )
      );

      this.root.classList.toggle(
        'cs-shop--fixed-local-context',
        isFixedLocalContext
      );

      if (!isFixedLocalContext) {
        banner.hidden = true;
        return;
      }

      const option = context.option;
      const isOrderAhead =
        context.shoppingPath ===
        'bakehouse_order_ahead';

      banner.hidden = false;

      const title = banner.querySelector(
        '[data-cs-shop-context-title]'
      );

      const copy = banner.querySelector(
        '[data-cs-shop-context-copy]'
      );

      const changeLink =
        banner.querySelector(
          '.cs-shop__context-change'
        );

      if (title) {
        title.textContent = isOrderAhead
          ? 'Cold Sugar Bakehouse — Order Ahead'
          : (
              option.display_name ||
              'Market pickup'
            );
      }

      if (copy) {
        if (isOrderAhead) {
          const details = [
            option.city_state ||
              'Georgetown, TX',
            'Pickup',
            '48+ hours ahead',
          ]
            .filter(Boolean)
            .join(' · ');

          copy.textContent =
            `${details} · ` +
            'Shop the full local menu.';
        } else {
          const details = [
            option.city_state,
            option.display_schedule ||
              option.time_window,
          ]
            .filter(Boolean)
            .join(' · ');

          copy.textContent =
            `${details}${details ? ' · ' : ''}` +
            'Shop the full local preorder menu.';
        }
      }

      if (changeLink) {
        changeLink.textContent =
          isOrderAhead
            ? 'Change shopping option'
            : 'Change location';
      }

      this.root
        .querySelectorAll(
          'a[href*="/products/"]'
        )
        .forEach((link) => {
          try {
            const url = new URL(
              link.href,
              window.location.origin
            );

            url.searchParams.set(
              'shopping_path',
              context.shoppingPath
            );

            url.searchParams.set(
              'fulfillment',
              context.fulfillmentHandle
            );

            link.href =
              `${url.pathname}` +
              `${url.search}` +
              `${url.hash}`;
          } catch (error) {
            // Leave the original product link intact.
          }
        });
    }

    getSelectedFulfillmentOption() {
      return this.shoppingContext?.option || null;
    }

    getExistingPickupLock(cart) {
      return (cart?.items || []).find((item) => this.isPickupLock(item)) || null;
    }

    pickupLockMatchesOption(item, option) {
      if (!item || !option) return false;

      const existingHandle = String(
        item.properties?._cold_sugar_fulfillment_option || ''
      );

      const existingVariantId = String(
        item.variant_id || item.id || ''
      );

      const targetVariantId = String(
        option.pickup_lock_variant_id || ''
      );

      return Boolean(
        (existingHandle && existingHandle === option.handle) ||
        (targetVariantId && existingVariantId === targetVariantId)
      );
    }

    async removePickupLockItems(items) {
      const updates = {};

      items.forEach((item) => {
        if (item?.key) updates[item.key] = 0;
      });

      if (!Object.keys(updates).length) return;

      const response = await fetch(this.route('cart/update.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ updates }),
      });

      if (!response.ok) {
        throw new Error(
          'We could not update the selected pickup location.'
        );
      }
    }

    async replaceMarketPickupLock(cart, option) {
      const existingLocks = (cart?.items || []).filter(
        (item) => this.isPickupLock(item)
      );

      if (!existingLocks.length) return;

      const matchingLock = existingLocks.find(
        (item) => this.pickupLockMatchesOption(item, option)
      );

      if (matchingLock) {
        const extraLocks = existingLocks.filter(
          (item) => item.key !== matchingLock.key
        );

        await this.removePickupLockItems(extraLocks);
        return;
      }

      if (!option.pickup_lock_variant_id) {
        throw new Error(
          `${option.display_name} is not connected to its Pickup Location lock variant yet.`
        );
      }

      const addResponse = await fetch(this.route('cart/add.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(option.pickup_lock_variant_id),
              quantity: 1,
              properties: {
                _cold_sugar_pickup_lock: 'true',
                _cold_sugar_fulfillment_option: option.handle,
              },
            },
          ],
        }),
      });

      const addResult = await addResponse.json().catch(() => ({}));

      if (!addResponse.ok || addResult.status) {
        throw new Error(
          addResult.description ||
          addResult.message ||
          `We could not switch your cart to ${option.display_name}.`
        );
      }

      try {
        await this.removePickupLockItems(existingLocks);
      } catch (error) {
        // Restore the previous state by removing the newly added lock.
        try {
          const cleanupCart = await this.fetchCart();
          const newLocks = (cleanupCart.items || []).filter(
            (item) =>
              this.isPickupLock(item) &&
              this.pickupLockMatchesOption(item, option)
          );

          await this.removePickupLockItems(newLocks);
        } catch (cleanupError) {
          console.warn(
            'Cold Sugar could not clean up the replacement pickup lock.',
            cleanupError
          );
        }

        throw error;
      }
    }

    buildShoppingPathAttributes(option, shoppingPath) {
      if (
        !option ||
        option.fulfillment_category !== 'pickup'
      ) {
        return {};
      }

      const isOrderAhead =
        shoppingPath ===
        'bakehouse_order_ahead';

      const optionName = isOrderAhead
        ? 'Cold Sugar Bakehouse — Order Ahead'
        : (
            option.display_name ||
            ''
          );

      const locationName = isOrderAhead
        ? 'Cold Sugar Bakehouse — Parmer Ranch'
        : (
            option.display_name ||
            ''
          );

      return {
        'Shopping Path':
          shoppingPath ||
          'market_pickup',

        'Porch Live Purchase': '',

        'Thursday Preorder Close Time': '',
        'Thursday Live Open Time': '',
        'Thursday Live Close Time': '',
        'Self Serve Purchase': '',
        'Self Serve Open Time': '',
        'Self Serve Close Time': '',

        'Fulfillment Category':
          isOrderAhead
            ? 'order_ahead'
            : 'pickup',

        'Fulfillment Type':
          isOrderAhead
            ? 'Pickup'
            : 'Pickup',

        'Fulfillment Option Handle':
          option.handle || '',

        'Fulfillment Option Name':
          optionName,

        'Pickup Event ID': '',
        'Pickup Date': '',
        'Pickup Day': '',

        'Pickup Location':
          locationName,

        'Pickup City State':
          option.city_state || '',

        'Pickup Address':
          option.full_address || '',

        'Pickup Window':
          isOrderAhead
            ? ''
            : (
                option.time_window ||
                option.display_schedule ||
                ''
              ),

        'Pickup Instructions':
          isOrderAhead
            ? ''
            : (
                option.customer_note ||
                ''
              ),

        'Delivery Event ID': '',
        'Delivery Date': '',
        'Delivery Day': '',

        'Delivery Area': '',

        'Delivery Window': '',
        'Delivery Zip Code': '',
        'Delivery Instructions': '',

        'Shipping Event ID': '',
        'Shipping Option': '',

        'Requested Delivery Date': '',
        'Requested Delivery Day': '',
        'Estimated Ship Date': '',
        'Shipping Method': '',

        'Checkout Method To Select':
          isOrderAhead
            ? 'Choose Pickup in store at checkout.'
            : (
                option.checkout_instruction ||
                `Choose Pickup in store → ${option.display_name}.`
              ),
      };
    }

    async persistShoppingPath(option, shoppingPath) {
      if (!option || option.fulfillment_category !== 'pickup') return;

      const response = await fetch(this.route('cart/update.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          attributes: this.buildShoppingPathAttributes(option, shoppingPath),
        }),
      });

      if (!response.ok) {
        throw new Error('Your shopping selection could not be saved. Please review it in the cart.');
      }
    }

    determineCartMode(cart) {
      const modes = new Set();
      let hasUnknownRealItem = false;

      (cart.items || []).forEach((item) => {
        if (this.isPickupLock(item)) return;

        const propertyMode = this.normalizeMode(
          item.properties && item.properties._cold_sugar_order_mode
        );
        const mappedMode = this.normalizeMode(
          this.modeMap[String(item.variant_id || item.id)]
        );
        const mode = propertyMode || mappedMode;

        if (mode) {
          modes.add(mode);
        } else {
          hasUnknownRealItem = true;
        }
      });

      if (modes.size === 0 && !hasUnknownRealItem) return 'empty';
      if (modes.size > 1 || hasUnknownRealItem) return 'mixed';

      return Array.from(modes)[0];
    }

    itemShoppingPath(item) {
      return String(
        item?.properties
          ?._cold_sugar_shopping_path ||
        ''
      )
        .trim()
        .toLowerCase();
    }

    cartHasShoppingPath(cart, shoppingPath) {
      const targetPath =
        String(shoppingPath || '')
          .trim()
          .toLowerCase();

      return (cart?.items || []).some(
        (item) =>
          !this.isPickupLock(item) &&
          Number(item.quantity || 0) > 0 &&
          this.itemShoppingPath(item) ===
            targetPath
      );
    }

    cartHasDifferentFixedLocalPath(
      cart,
      targetShoppingPath
    ) {
      const fixedLocalPaths =
        new Set([
          'bakehouse_order_ahead',
          'market_pickup',
          'parmer_self_serve',
        ]);

      const targetPath =
        String(
          targetShoppingPath || ''
        )
          .trim()
          .toLowerCase();

      return (cart?.items || []).some(
        (item) => {
          if (
            this.isPickupLock(item) ||
            Number(item.quantity || 0) <= 0
          ) {
            return false;
          }

          const itemPath =
            this.itemShoppingPath(item);

          return (
            fixedLocalPaths.has(itemPath) &&
            itemPath !== targetPath
          );
        }
      );
    }

    buildMigratedLineProperties(
      item,
      shoppingPath
    ) {
      const properties = {
        ...(item?.properties || {}),
      };

      delete properties
        ._cold_sugar_porch_event;

      properties
        ._cold_sugar_order_mode =
        'local';

      properties
        ._cold_sugar_shopping_path =
        shoppingPath;

      return properties;
    }

    linePropertySignature(
      properties,
      {
        customerOnly = false,
      } = {}
    ) {
      const internalKeys =
        new Set([
          '_cold_sugar_order_mode',
          '_cold_sugar_shopping_path',
          '_cold_sugar_porch_event',
        ]);

      return JSON.stringify(
        Object.entries(
          properties || {}
        )
          .filter(([key, value]) => {
            if (
              customerOnly &&
              internalKeys.has(key)
            ) {
              return false;
            }

            return (
              value !== null &&
              value !== undefined &&
              value !== ''
            );
          })
          .sort(
            ([firstKey], [secondKey]) =>
              firstKey.localeCompare(
                secondKey
              )
          )
          .map(([key, value]) => [
            key,
            String(value),
          ])
      );
    }

    lineSellingPlanId(item) {
      return String(
        item?.selling_plan_allocation
          ?.selling_plan?.id ||
        ''
      );
    }

    linesShareCustomerIdentity(
      first,
      second
    ) {
      return (
        String(
          first?.variant_id ||
          first?.id ||
          ''
        ) ===
          String(
            second?.variant_id ||
            second?.id ||
            ''
          ) &&
        this.lineSellingPlanId(first) ===
          this.lineSellingPlanId(second) &&
        this.linePropertySignature(
          first?.properties,
          {
            customerOnly: true,
          }
        ) ===
          this.linePropertySignature(
            second?.properties,
            {
              customerOnly: true,
            }
          )
      );
    }

    linesShareExactIdentity(
      first,
      second
    ) {
      return (
        String(
          first?.variant_id ||
          first?.id ||
          ''
        ) ===
          String(
            second?.variant_id ||
            second?.id ||
            ''
          ) &&
        this.lineSellingPlanId(first) ===
          this.lineSellingPlanId(second) &&
        this.linePropertySignature(
          first?.properties
        ) ===
          this.linePropertySignature(
            second?.properties
          )
      );
    }

    async updateCartLineQuantities(
      updates,
      fallbackMessage
    ) {
      const response = await fetch(
        this.route('cart/update.js'),
        {
          method: 'POST',
          headers: {
            Accept:
              'application/json',
            'Content-Type':
              'application/json',
            'X-Requested-With':
              'XMLHttpRequest',
          },
          body: JSON.stringify({
            updates,
          }),
        }
      );

      const payload =
        await response
          .json()
          .catch(() => ({}));

      if (
        !response.ok ||
        payload.status ||
        payload.errors
      ) {
        throw new Error(
          payload.description ||
          payload.message ||
          fallbackMessage
        );
      }

      return payload;
    }

    async changeMigratedCartLine(
      item,
      shoppingPath
    ) {
      const response = await fetch(
        this.route('cart/change.js'),
        {
          method: 'POST',
          headers: {
            Accept:
              'application/json',
            'Content-Type':
              'application/json',
            'X-Requested-With':
              'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: Number(
              item.quantity || 0
            ),
            properties:
              this.buildMigratedLineProperties(
                item,
                shoppingPath
              ),
          }),
        }
      );

      const payload =
        await response
          .json()
          .catch(() => ({}));

      if (
        !response.ok ||
        payload.status ||
        payload.errors
      ) {
        throw new Error(
          payload.description ||
          payload.message ||
          'A cart product could not be moved to the new order location.'
        );
      }

      return payload;
    }

    async migrateLocalCartToShoppingPath(
      cart,
      option,
      shoppingPath
    ) {
      if (
        ![
          'bakehouse_order_ahead',
          'market_pickup',
        ].includes(shoppingPath)
      ) {
        return cart;
      }

      if (
        !option ||
        option.fulfillment_category !==
          'pickup'
      ) {
        throw new Error(
          'The new order location could not be confirmed.'
        );
      }

      let workingCart =
        cart;

      // Convert one mismatched local line at a time.
      // Refetch after every mutation because line keys can change.
      for (
        let pass = 0;
        pass < 100;
        pass += 1
      ) {
        workingCart =
          await this.fetchCart();

        const visibleItems =
          (workingCart.items || [])
            .filter(
              (item) =>
                !this.isPickupLock(item) &&
                Number(
                  item.quantity || 0
                ) > 0
            );

        const sourceLine =
          visibleItems.find(
            (item) => {
              const itemPath =
                this.itemShoppingPath(
                  item
                );

              const itemMode =
                String(
                  item?.properties
                    ?._cold_sugar_order_mode ||
                  ''
                )
                  .trim()
                  .toLowerCase();

              return (
                (
                  itemMode === 'local' &&
                  !itemPath
                ) ||
                itemPath ===
                  'porch_live' ||
                itemPath ===
                  'parmer_self_serve' ||
                (
                  [
                    'bakehouse_order_ahead',
                    'market_pickup',
                  ].includes(
                    itemPath
                  ) &&
                  itemPath !==
                    shoppingPath
                )
              );
            }
          );

        if (!sourceLine) {
          break;
        }

        const matchingTarget =
          visibleItems.find(
            (item) =>
              item.key !==
                sourceLine.key &&
              this.itemShoppingPath(
                item
              ) ===
                shoppingPath &&
              this
                .linesShareCustomerIdentity(
                  sourceLine,
                  item
                )
          );

        if (matchingTarget) {
          await this
            .updateCartLineQuantities(
              {
                [matchingTarget.key]:
                  Number(
                    matchingTarget
                      .quantity || 0
                  ) +
                  Number(
                    sourceLine
                      .quantity || 0
                  ),

                [sourceLine.key]: 0,
              },
              'Matching cart quantities could not be combined.'
            );
        } else {
          await this
            .changeMigratedCartLine(
              sourceLine,
              shoppingPath
            );
        }

        if (pass === 99) {
          throw new Error(
            'The cart could not be fully converted to the new order location.'
          );
        }
      }

      // Consolidate any exact duplicate lines that remain.
      for (
        let pass = 0;
        pass < 100;
        pass += 1
      ) {
        workingCart =
          await this.fetchCart();

        const targetLines =
          (workingCart.items || [])
            .filter(
              (item) =>
                !this.isPickupLock(item) &&
                Number(
                  item.quantity || 0
                ) > 0 &&
                this.itemShoppingPath(
                  item
                ) === shoppingPath
            );

        let duplicateGroup = null;

        for (
          let index = 0;
          index < targetLines.length;
          index += 1
        ) {
          const first =
            targetLines[index];

          const matches =
            targetLines.filter(
              (candidate) =>
                this.linesShareExactIdentity(
                  first,
                  candidate
                )
            );

          if (matches.length > 1) {
            duplicateGroup =
              matches;
            break;
          }
        }

        if (!duplicateGroup) {
          break;
        }

        const keeper =
          duplicateGroup[0];

        const totalQuantity =
          duplicateGroup.reduce(
            (total, item) =>
              total +
              Number(
                item.quantity || 0
              ),
            0
          );

        const updates = {
          [keeper.key]:
            totalQuantity,
        };

        duplicateGroup
          .slice(1)
          .forEach((item) => {
            updates[item.key] = 0;
          });

        await this
          .updateCartLineQuantities(
            updates,
            'Duplicate cart lines could not be combined.'
          );

        if (pass === 99) {
          throw new Error(
            'Duplicate cart lines could not be fully consolidated.'
          );
        }
      }

      workingCart =
        await this.fetchCart();

      await this
        .replaceMarketPickupLock(
          workingCart,
          option
        );

      await this.persistShoppingPath(
        option,
        shoppingPath
      );

      return this.fetchCart();
    }

    isPickupLock(item) {
      const value = item.properties && item.properties._cold_sugar_pickup_lock;

      return (
        value === true ||
        value === 'true' ||
        value === 1 ||
        value === '1' ||
        item.handle === 'pickup-location'
      );
    }

    normalizeMode(value) {
      const mode = String(value || '').trim().toLowerCase();
      return ['local', 'shipping'].includes(mode) ? mode : '';
    }

    openModeDialog(cartMode, pending) {
      if (!this.dialog) {
        this.showFormError(
          pending.form,
          'Local and shipped products require separate orders.'
        );
        return;
      }

      this.pendingAdd = {
        ...pending,
        cartMode,
      };
      this.lastFocusedElement = document.activeElement;

      const title = this.dialog.querySelector('[data-cs-dialog-title]');
      const message = this.dialog.querySelector('[data-cs-dialog-message]');
      const keepButton = this.dialog.querySelector('[data-cs-dialog-keep]');
      const switchButton = this.dialog.querySelector('[data-cs-dialog-switch]');

      if (pending.orderMode === 'shipping' && cartMode === 'local') {
        title.textContent = 'Start a shipped order?';
        message.textContent =
          'Your cart currently contains items for local pickup or delivery. Shipped and local items must be placed as separate orders.';
        keepButton.textContent = 'Keep my local order';
        switchButton.textContent = 'Clear cart & start shipped order';
      } else if (pending.orderMode === 'local' && cartMode === 'shipping') {
        title.textContent = 'Start a local order?';
        message.textContent =
          'Your cart currently contains items that ship. Local pickup and delivery items must be placed as a separate order.';
        keepButton.textContent = 'Keep my shipped order';
        switchButton.textContent = 'Clear cart & start local order';
      } else {
        title.textContent =
          pending.orderMode === 'shipping'
            ? 'Start a shipped order?'
            : 'Start a local order?';
        message.textContent =
          'Your cart currently contains items with different fulfillment requirements. Clear it to begin a new order with this item.';
        keepButton.textContent = 'Keep my current cart';
        switchButton.textContent =
          pending.orderMode === 'shipping'
            ? 'Clear cart & start shipped order'
            : 'Clear cart & start local order';
      }

      if (typeof this.dialog.showModal === 'function') {
        this.dialog.showModal();
      } else {
        this.dialog.setAttribute('open', '');
      }
    }

    keepCurrentOrder() {
      const cartMode = this.normalizeMode(this.pendingAdd?.cartMode);

      if (cartMode) {
        this.setMode(cartMode, { updateUrl: true });

        const activeTab = this.tabs.find(
          (tab) => tab.dataset.shopMode === cartMode
        );

        if (activeTab) {
          this.lastFocusedElement = activeTab;
        }
      }

      this.closeModeDialog();

      if (cartMode) {
        const panel = this.getPanel(cartMode);

        window.requestAnimationFrame(() => {
          panel?.scrollIntoView({
            behavior: this.prefersReducedMotion() ? 'auto' : 'smooth',
            block: 'start',
          });
        });
      }
    }

    closeModeDialog() {
      if (!this.dialog) return;

      this.pendingAdd = null;

      if (typeof this.dialog.close === 'function' && this.dialog.open) {
        this.dialog.close();
      } else {
        this.dialog.removeAttribute('open');
        this.restoreDialogFocus();
      }
    }

    restoreDialogFocus() {
      if (this.lastFocusedElement instanceof HTMLElement) {
        this.lastFocusedElement.focus();
      }

      this.lastFocusedElement = null;
    }

    async confirmModeSwitch() {
      if (!this.pendingAdd) return;

      const pending = this.pendingAdd;
      const switchButton = this.dialog?.querySelector('[data-cs-dialog-switch]');
      const keepButton = this.dialog?.querySelector('[data-cs-dialog-keep]');
      const closeButton = this.dialog?.querySelector('[data-cs-dialog-close]');

      if (switchButton) {
        switchButton.disabled = true;
        switchButton.textContent = 'Starting new order…';
      }
      if (keepButton) keepButton.disabled = true;
      if (closeButton) closeButton.disabled = true;

      try {
        await this.clearCartAndFulfillment();
        await this.addPendingItem(pending, { items: [], attributes: {} });

        if (typeof this.dialog?.close === 'function' && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog?.removeAttribute('open');
        }

        this.pendingAdd = null;
      } catch (error) {
        this.showFormError(
          pending.form,
          error.message || 'We could not start the new order. Please try again.'
        );

        if (typeof this.dialog?.close === 'function' && this.dialog.open) {
          this.dialog.close();
        } else {
          this.dialog?.removeAttribute('open');
        }

        this.setFormLoading(pending.form, false);
        this.pendingAdd = null;
      } finally {
        if (switchButton) switchButton.disabled = false;
        if (keepButton) keepButton.disabled = false;
        if (closeButton) closeButton.disabled = false;
      }
    }

    async clearCartAndFulfillment() {
      const clearResponse = await fetch(this.route('cart/clear.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({}),
      });

      if (!clearResponse.ok) {
        throw new Error('We could not clear the current cart.');
      }

      const attributes = {};
      STALE_FULFILLMENT_ATTRIBUTES.forEach((name) => {
        attributes[name] = '';
      });

      const updateResponse = await fetch(this.route('cart/update.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({ attributes }),
      });

      if (!updateResponse.ok) {
        throw new Error('We could not reset the previous fulfillment selection.');
      }
    }

    async addPendingItem(pending, cart = null) {
      this.setFormLoading(pending.form, true);
      let addedSuccessfully = false;

      try {
        const cartUi =
          document.querySelector('cart-drawer') ||
          document.querySelector('cart-notification');

        const option = this.getSelectedFulfillmentOption();
        const shoppingPath = this.shoppingContext?.shoppingPath || '';
        const currentCart = cart || (await this.fetchCart());

        if (pending.orderMode === 'shipping') {
          const shippingBox =
            window.ColdSugarShippingBox;

          if (
            !shippingBox ||
            typeof shippingBox.previewAdd !== 'function'
          ) {
            throw new Error(
              'Shipping box protection is still loading. Please wait a moment and try again.'
            );
          }

          if (!pending.shippingPackType) {
            throw new Error(
              'This shipped item is missing its box-packing information. Please contact us before ordering.'
            );
          }

          const packingResult =
            shippingBox.previewAdd(
              currentCart.items || [],
              pending.shippingPackType,
              pending.quantity
            );

          if (!packingResult.valid) {
            throw new Error(
              packingResult.message ||
              'That combination will not fit in our available shipping boxes.'
            );
          }
        }

        const existingLock = this.getExistingPickupLock(currentCart);

        const usesLocationLock = [
          'market_pickup',
          'bakehouse_order_ahead',
        ].includes(shoppingPath);

        const items = [
          {
            id: pending.variantId,
            quantity: pending.quantity,
            properties: {
              _cold_sugar_order_mode: pending.orderMode,
              ...(pending.orderMode === 'shipping' && pending.shippingPackType
                ? { _cold_sugar_shipping_pack_type: pending.shippingPackType }
                : {}),
              ...(shoppingPath ? { _cold_sugar_shopping_path: shoppingPath } : {}),
            },
          },
        ];

        if (
          pending.orderMode === 'local' &&
          usesLocationLock &&
          option?.fulfillment_category === 'pickup'
        ) {
          if (existingLock) {
            await this.replaceMarketPickupLock(currentCart, option);
          } else {
            if (!option.pickup_lock_variant_id) {
              throw new Error(
                `${option.display_name} is not connected to its Pickup Location lock variant yet.`
              );
            }

            items.push({
              id: Number(option.pickup_lock_variant_id),
              quantity: 1,
              properties: {
                _cold_sugar_pickup_lock: 'true',
                _cold_sugar_fulfillment_option: option.handle,
              },
            });
          }
        }

        const response = await fetch(this.route('cart/add.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({ items }),
        });

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(
            result.description ||
              result.message ||
              'This item could not be added to your cart.'
          );
        }

        if (
          pending.orderMode === 'local' &&
          usesLocationLock &&
          option?.fulfillment_category === 'pickup'
        ) {
          await this.persistShoppingPath(option, shoppingPath);
        }

        await this.refreshCartUi(
          cartUi,
          {
            openCartUi:
              pending.openCartUi !== false &&
              pending.orderMode !==
                'shipping',
            expandShopDock:
              pending.openCartUi === false
          }
        );
        addedSuccessfully = true;
      } finally {
        this.setFormLoading(pending.form, false);
      }

      if (addedSuccessfully) {
        this.showAddedState(pending.form);
      }
    }

    async refreshCartUi(
      cartUi,
      {
        openCartUi = true,
        expandShopDock = false
      } = {}
    ) {
      const cart = await this.fetchCart();
      this.updateVisibleCartCount(cart);
      await this.syncQuickAddControls(cart);

      let activeCartUi = cartUi;

      if (cartUi && cartUi.tagName === 'CART-DRAWER') {
        activeCartUi = await this.refreshCartDrawer(cartUi, cart);
      } else if (cartUi && cartUi.tagName === 'CART-NOTIFICATION') {
        this.refreshCartNotification(cartUi, cart);
      } else {
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart },
          })
        );
      }

      window.ColdSugarShippingBoxUI
        ?.renderAll(cart);

      this.renderLocalCartDock(
        cart
      );

      if (expandShopDock) {
        this.expandActiveShopDock();
      }

      if (
        openCartUi &&
        activeCartUi &&
        typeof activeCartUi.open ===
          'function'
      ) {
        activeCartUi.open();
      }
    }

    refreshCartNotification(cartNotification, cart) {
      const container = cartNotification.querySelector('#cart-notification-product');
      if (!container) return;

      const visibleItems = (cart.items || []).filter((item) => !this.isPickupLock(item));
      container.replaceChildren();

      const list = document.createElement('div');
      list.className = 'cs-cart-notification__items';
      list.setAttribute('role', 'list');

      visibleItems.forEach((item) => {
        const row = document.createElement('article');
        row.className = 'cs-cart-notification__item';
        row.setAttribute('role', 'listitem');
        row.dataset.cartItemKey = item.key;

        const imageLink = document.createElement('a');
        imageLink.className = 'cs-cart-notification__image-link';
        imageLink.href = item.url || '#';
        imageLink.setAttribute('aria-label', `View ${item.product_title || 'product'}`);

        if (item.image) {
          const image = document.createElement('img');
          image.className = 'cs-cart-notification__image';
          image.src = item.image;
          image.alt = item.featured_image?.alt || item.product_title || '';
          image.loading = 'lazy';
          image.width = 96;
          image.height = 96;
          imageLink.appendChild(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'cs-cart-notification__image-placeholder';
          placeholder.setAttribute('aria-hidden', 'true');
          imageLink.appendChild(placeholder);
        }

        const details = document.createElement('div');
        details.className = 'cs-cart-notification__details';

        const title = document.createElement('a');
        title.className = 'cs-cart-notification__title';
        title.href = item.url || '#';
        title.textContent = item.product_title || item.title || 'Product';
        details.appendChild(title);

        if (item.variant_title && item.variant_title !== 'Default Title') {
          const variant = document.createElement('p');
          variant.className = 'cs-cart-notification__variant';
          variant.textContent = item.variant_title;
          details.appendChild(variant);
        }

        const quantityRule = item.quantity_rule || {};
        const minimum = Math.max(1, Number(quantityRule.min) || 1);
        const increment = Math.max(1, Number(quantityRule.increment) || 1);
        const maximum = quantityRule.max ? Number(quantityRule.max) : null;

        const lineControls = document.createElement('div');
        lineControls.className = 'cs-cart-notification__line-controls';

        const quantity = document.createElement('div');
        quantity.className = 'cs-cart-notification__quantity';

        const minus = document.createElement('button');
        minus.className = 'cs-cart-notification__quantity-button';
        minus.type = 'button';
        minus.dataset.notificationQuantityMinus = '';
        minus.setAttribute(
          'aria-label',
          `Decrease quantity for ${item.product_title || 'product'}`
        );
        minus.textContent = '−';
        minus.disabled = Number(item.quantity) <= minimum;

        const input = document.createElement('input');
        input.className = 'cs-cart-notification__quantity-input';
        input.type = 'number';
        input.value = String(item.quantity);
        input.min = String(minimum);
        input.step = String(increment);
        input.inputMode = 'numeric';
        input.dataset.notificationQuantityInput = '';
        input.setAttribute(
          'aria-label',
          `Quantity for ${item.product_title || 'product'}`
        );

        if (maximum) {
          input.max = String(maximum);
        }

        const plus = document.createElement('button');
        plus.className = 'cs-cart-notification__quantity-button';
        plus.type = 'button';
        plus.dataset.notificationQuantityPlus = '';
        plus.setAttribute(
          'aria-label',
          `Increase quantity for ${item.product_title || 'product'}`
        );
        plus.textContent = '+';
        plus.disabled = maximum ? Number(item.quantity) >= maximum : false;

        quantity.append(minus, input, plus);

        const linePrice = document.createElement('span');
        linePrice.className = 'cs-cart-notification__line-price';
        linePrice.textContent = this.formatCartMoney(
          item.final_line_price ?? item.line_price ?? 0,
          cart.currency
        );

        lineControls.append(quantity, linePrice);

        const remove = document.createElement('button');
        remove.className = 'cs-cart-notification__remove';
        remove.type = 'button';
        remove.dataset.notificationRemove = '';
        remove.textContent = 'Remove';
        remove.setAttribute(
          'aria-label',
          `Remove ${item.product_title || 'product'} from cart`
        );

        const updateQuantity = async (requestedQuantity) => {
          const normalized = this.normalizeNotificationQuantity(
            requestedQuantity,
            minimum,
            maximum,
            increment
          );

          input.value = String(normalized);

          if (normalized === Number(item.quantity)) return;

          /*
            Removing or decreasing an item is always safe.
            Nationwide shipping increases must fit the available
            shipping-box rules before Shopify is allowed to update
            the cart.
          */
          if (normalized > Number(item.quantity)) {
            const orderMode = String(
              item?.properties?._cold_sugar_order_mode || ''
            )
              .trim()
              .toLowerCase();

            if (orderMode === 'shipping') {
              const shippingBox =
                window.ColdSugarShippingBox;

              if (
                !shippingBox ||
                typeof shippingBox.previewLineQuantity !==
                  'function'
              ) {
                input.value = String(item.quantity);

                this.showNotificationError(
                  row,
                  'Shipping box protection is still loading. Please wait a moment and try again.'
                );

                return;
              }

              const packingResult =
                shippingBox.previewLineQuantity(
                  cart.items || [],
                  item.key,
                  normalized
                );

              if (!packingResult.valid) {
                input.value = String(item.quantity);

                this.showNotificationError(
                  row,
                  packingResult.message ||
                    'That quantity will not fit in our available shipping boxes.'
                );

                return;
              }
            }
          }

          await this.changeNotificationCartLine(
            cartNotification,
            item.key,
            normalized,
            row
          );
        };

        minus.addEventListener('click', async () => {
          await updateQuantity(Number(input.value) - increment);
        });

        plus.addEventListener('click', async () => {
          await updateQuantity(Number(input.value) + increment);
        });

        input.addEventListener('change', async () => {
          await updateQuantity(Number(input.value));
        });

        input.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            input.blur();
          }
        });

        remove.addEventListener('click', async () => {
          await this.changeNotificationCartLine(
            cartNotification,
            item.key,
            0,
            row
          );
        });

        details.append(lineControls, remove);
        row.append(imageLink, details);
        list.appendChild(row);
      });

      const summary = document.createElement('div');
      summary.className = 'cs-cart-notification__summary';

      const count = visibleItems.reduce(
        (total, item) => total + Number(item.quantity || 0),
        0
      );

      const countLabel = document.createElement('span');
      countLabel.textContent = `${count} ${count === 1 ? 'item' : 'items'}`;

      const subtotal = document.createElement('span');
      subtotal.innerHTML = `<strong>Subtotal</strong> ${this.formatCartMoney(
        cart.items_subtotal_price ?? cart.total_price ?? 0,
        cart.currency
      )}`;

      summary.append(countLabel, subtotal);
      container.append(list, summary);

      const shippingBoxSlot =
        cartNotification.querySelector(
          '[data-cs-shipping-box-notification-slot]'
        );

      if (shippingBoxSlot) {
        shippingBoxSlot.replaceChildren();

        const shippingBoxStatus =
          window.ColdSugarShippingBoxUI
            ?.createNotificationStatus?.(cart);

        if (shippingBoxStatus) {
          shippingBoxSlot.appendChild(
            shippingBoxStatus
          );
          shippingBoxSlot.hidden = false;
        } else {
          shippingBoxSlot.hidden = true;
        }
      }
    }

    normalizeNotificationQuantity(value, minimum, maximum, increment) {
      let quantity = Number(value);

      if (!Number.isFinite(quantity)) {
        quantity = minimum;
      }

      quantity = Math.max(minimum, quantity);

      const steps = Math.round((quantity - minimum) / increment);
      quantity = minimum + steps * increment;

      if (maximum) {
        quantity = Math.min(maximum, quantity);
      }

      return quantity;
    }

    async changeNotificationCartLine(cartNotification, itemKey, quantity, row) {
      this.setNotificationLineLoading(row, true);
      this.clearNotificationError(row);

      try {
        const response = await fetch(this.route('cart/change.js'), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: JSON.stringify({
            id: itemKey,
            quantity,
          }),
        });

        const result = await response.json();

        if (!response.ok || result.status) {
          throw new Error(
            result.description ||
              result.message ||
              'We could not update this item.'
          );
        }

        const cart = await this.cleanupNotificationCartIfEmpty(result);
        this.updateVisibleCartCount(cart);

        const visibleItems = (cart.items || []).filter(
          (item) => !this.isPickupLock(item)
        );

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart },
          })
        );

        if (visibleItems.length === 0) {
          if (typeof cartNotification.close === 'function') {
            cartNotification.close();
          }
          return;
        }

        this.refreshCartNotification(cartNotification, cart);
      } catch (error) {
        this.setNotificationLineLoading(row, false);
        this.showNotificationError(
          row,
          error.message || 'We could not update this item. Please try again.'
        );
      }
    }

    async cleanupNotificationCartIfEmpty(cart) {
      const visibleItems = (cart.items || []).filter(
        (item) => !this.isPickupLock(item)
      );

      if (visibleItems.length > 0) {
        return cart;
      }

      const updates = {};

      (cart.items || []).forEach((item) => {
        if (this.isPickupLock(item)) {
          updates[item.key] = 0;
        }
      });

      const attributes = {};
      STALE_FULFILLMENT_ATTRIBUTES.forEach((name) => {
        attributes[name] = '';
      });

      const response = await fetch(this.route('cart/update.js'), {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: JSON.stringify({
          updates,
          attributes,
        }),
      });

      if (!response.ok) {
        throw new Error('The item was removed, but the cart could not be fully reset.');
      }

      return response.json();
    }

    setNotificationLineLoading(row, isLoading) {
      if (!row) return;

      row.classList.toggle('is-updating', isLoading);
      row.setAttribute('aria-busy', String(isLoading));

      row.querySelectorAll('button, input').forEach((control) => {
        control.disabled = isLoading;
      });
    }

    showNotificationError(row, message) {
      if (!row) return;

      let error = row.querySelector('[data-notification-line-error]');

      if (!error) {
        error = document.createElement('p');
        error.className = 'cs-cart-notification__error';
        error.dataset.notificationLineError = '';
        error.setAttribute('role', 'alert');
        row.querySelector('.cs-cart-notification__details')?.appendChild(error);
      }

      error.textContent = message;
    }

    clearNotificationError(row) {
      row?.querySelector('[data-notification-line-error]')?.remove();
    }

    formatCartMoney(cents, currency = 'USD') {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency,
        }).format(Number(cents || 0) / 100);
      } catch (error) {
        return `$${(Number(cents || 0) / 100).toFixed(2)}`;
      }
    }

    async refreshCartDrawer(cartDrawer, cart) {
      try {
        const response = await fetch(this.route('cart?section_id=cart-drawer'), {
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
          },
        });

        if (!response.ok) {
          throw new Error('The cart drawer could not be refreshed.');
        }

        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const sourceDrawer = html.querySelector('cart-drawer');

        if (!sourceDrawer) {
          throw new Error('The refreshed cart drawer markup was not found.');
        }

        cartDrawer.innerHTML = sourceDrawer.innerHTML;
        cartDrawer.className = sourceDrawer.className;

        const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof cartDrawer.close === 'function') {
          overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
        }

        const summary = cartDrawer.querySelector('[id^="Details-"] summary');
        if (summary && typeof cartDrawer.setSummaryAccessibility === 'function') {
          cartDrawer.setSummaryAccessibility(summary);
        }

        const visibleCount = (cart.items || []).reduce((total, item) => {
          return this.isPickupLock(item) ? total : total + Number(item.quantity || 0);
        }, 0);

        cartDrawer.classList.toggle('is-empty', visibleCount === 0);
        return cartDrawer;
      } catch (error) {
        console.error('Cold Sugar cart drawer refresh failed:', error);

        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            bubbles: true,
            detail: { cart },
          })
        );

        return cartDrawer;
      }
    }

    updateVisibleCartCount(cart) {
      const visibleCount = (cart.items || []).reduce((total, item) => {
        return this.isPickupLock(item) ? total : total + Number(item.quantity || 0);
      }, 0);

      const cartIcon =
        document.getElementById('cart-icon-bubble');

      let headerBubble =
        cartIcon?.querySelector(
          '.cart-count-bubble'
        ) || null;

      /*
        When Liquid rendered the page with an empty cart there is no
        cart-count-bubble element to update. Create it as soon as the
        first visible item is added so Nationwide behaves like the
        local shopping experiences without requiring a refresh.
      */
      if (
        visibleCount > 0 &&
        cartIcon &&
        !headerBubble
      ) {
        headerBubble =
          document.createElement('div');

        headerBubble.className =
          'cart-count-bubble';

        const visibleNumber =
          document.createElement('span');

        visibleNumber.setAttribute(
          'aria-hidden',
          'true'
        );

        const accessibleCount =
          document.createElement('span');

        accessibleCount.className =
          'visually-hidden';

        headerBubble.append(
          visibleNumber,
          accessibleCount
        );

        cartIcon.appendChild(headerBubble);
      }

      document
        .querySelectorAll(
          '[data-cart-count], .cart-count-bubble span[aria-hidden="true"]'
        )
        .forEach((node) => {
          node.textContent =
            String(visibleCount);
        });

      document
        .querySelectorAll(
          '.cart-count-bubble .visually-hidden'
        )
        .forEach((node) => {
          node.textContent =
            `${visibleCount} ${
              visibleCount === 1
                ? 'item'
                : 'items'
            } in cart`;
        });

      document
        .querySelectorAll(
          '.cart-count-bubble'
        )
        .forEach((bubble) => {
          const isEmpty =
            visibleCount === 0;

          bubble.classList.toggle(
            'hidden',
            isEmpty
          );

          bubble.toggleAttribute(
            'hidden',
            isEmpty
          );
        });
    }

    async fetchCart() {
      const response = await fetch(this.route('cart.js'), {
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      });

      if (!response.ok) {
        throw new Error('We could not read your cart. Please try again.');
      }

      return response.json();
    }

    route(path) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return `${root.replace(/\/?$/, '/')}${String(path).replace(/^\//, '')}`;
    }

    setFormLoading(form, isLoading) {
      form.classList.toggle(
        'is-loading',
        isLoading
      );

      form.setAttribute(
        'aria-busy',
        String(isLoading)
      );

      const select =
        form.querySelector(
          '[data-variant-select]'
        );

      const minus =
        form.querySelector(
          '[data-quantity-minus]'
        );

      const plus =
        form.querySelector(
          '[data-quantity-plus]'
        );

      if (isLoading) {
        if (select) {
          select.disabled = true;
        }

        if (minus) {
          minus.disabled = true;
        }

        if (plus) {
          plus.disabled = true;
        }

        return;
      }

      if (select) {
        select.disabled = false;
      }

      this.updateVariantState(form);
    }

    showAddedState(form) {
      const quantity =
        form.querySelector(
          '[data-live-cart-quantity]'
        );

      if (!quantity) {
        return;
      }

      quantity.classList.add(
        'is-just-updated'
      );

      window.setTimeout(
        () => {
          quantity.classList.remove(
            'is-just-updated'
          );
        },
        650
      );
    }

    showFormError(form, message) {
      const error = form.querySelector('[data-quick-add-error]');
      if (!error) return;

      error.textContent = message;
      error.hidden = false;
    }

    clearFormError(form) {
      const error = form.querySelector('[data-quick-add-error]');
      if (!error) return;

      error.textContent = '';
      error.hidden = true;
    }

    updateUrl({ mode, category }) {
      const url = new URL(window.location.href);
      url.searchParams.set('mode', mode);

      if (category) {
        url.searchParams.set('category', category);
      } else {
        url.searchParams.delete('category');
      }

      window.history.replaceState({}, '', url);
    }

    prefersReducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    escapeHTML(value) {
      return String(value || '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    }

    escapeSelector(value) {
      if (window.CSS && typeof window.CSS.escape === 'function') {
        return window.CSS.escape(value);
      }

      return String(value).replace(/["\\]/g, '\\$&');
    }
  }

  const initialize = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach((root) => {
      new ColdSugarShop(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
